export default {
  v: "5.3.1",
  fr: 25,
  ip: 0,
  op: 125,
  w: 1080,
  h: 1080,
  nm: "LOOK RIGHT 2",
  ddd: 1,
  assets: [{
    id: "comp_0",
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "Shape Layer 39",
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [316, 316, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          ty: "rc",
          d: 1,
          s: {
            a: 0,
            k: [54.219, 23.734],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 4
          },
          nm: "Rectangle Path 1",
          mn: "ADBE Vector Shape - Rect",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.23529399797, 0.525489956725, 0.521568986481, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.596078431373, 0.505882352941, 0.400000029919, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [5.262, 202.848],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [253.905, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Rectangle 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 0,
      op: 500,
      st: 0,
      bm: 0
    }, {
      ddd: 0,
      ind: 3,
      ty: 3,
      nm: "Eyes",
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 0,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [316, 343, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      ip: 0,
      op: 500,
      st: 0,
      bm: 0
    }, {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: "Shape Layer 38",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [244, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.862745157878, 0.725490196078, 0.572549019608, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 740,
      op: 740.252525252525,
      st: -13,
      bm: 0
    }, {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: "Shape Layer 32",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [244, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.862745157878, 0.725490196078, 0.572549019608, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 617,
      op: 617.252525252525,
      st: -136,
      bm: 0
    }, {
      ddd: 0,
      ind: 6,
      ty: 4,
      nm: "Shape Layer 26",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [244, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.862745157878, 0.725490196078, 0.572549019608, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 492,
      op: 498,
      st: -261,
      bm: 0
    }, {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: "Shape Layer 20",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [244, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.862745157878, 0.725490196078, 0.572549019608, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 366,
      op: 372,
      st: -387,
      bm: 0
    }, {
      ddd: 0,
      ind: 8,
      ty: 4,
      nm: "Shape Layer 8",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [244, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.862745157878, 0.725490196078, 0.572549019608, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 109,
      op: 115,
      st: -644,
      bm: 0
    }, {
      ddd: 0,
      ind: 9,
      ty: 4,
      nm: "Shape Layer 37",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [244, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.862745157878, 0.725490196078, 0.572549019608, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 721,
      op: 721.252525252525,
      st: -32,
      bm: 0
    }, {
      ddd: 0,
      ind: 10,
      ty: 4,
      nm: "Shape Layer 31",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [244, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.862745157878, 0.725490196078, 0.572549019608, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 598,
      op: 598.252525252525,
      st: -155,
      bm: 0
    }, {
      ddd: 0,
      ind: 11,
      ty: 4,
      nm: "Shape Layer 25",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [244, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.862745157878, 0.725490196078, 0.572549019608, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 473,
      op: 477,
      st: -280,
      bm: 0
    }, {
      ddd: 0,
      ind: 12,
      ty: 4,
      nm: "Shape Layer 19",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [244, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.862745157878, 0.725490196078, 0.572549019608, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 347,
      op: 351,
      st: -406,
      bm: 0
    }, {
      ddd: 0,
      ind: 13,
      ty: 4,
      nm: "Shape Layer 7",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [244, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.862745157878, 0.725490196078, 0.572549019608, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 100,
      op: 104,
      st: -653,
      bm: 0
    }, {
      ddd: 0,
      ind: 14,
      ty: 4,
      nm: "Shape Layer 36",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [244, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 659,
      op: 659.252525252525,
      st: -94,
      bm: 0
    }, {
      ddd: 0,
      ind: 15,
      ty: 4,
      nm: "Shape Layer 30",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [244, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 536,
      op: 536.252525252525,
      st: -217,
      bm: 0
    }, {
      ddd: 0,
      ind: 16,
      ty: 4,
      nm: "Shape Layer 24",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [244, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 411,
      op: 417,
      st: -342,
      bm: 0
    }, {
      ddd: 0,
      ind: 17,
      ty: 4,
      nm: "Shape Layer 18",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [244, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 285,
      op: 291,
      st: -468,
      bm: 0
    }, {
      ddd: 0,
      ind: 18,
      ty: 4,
      nm: "Shape Layer 12",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [244, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 163,
      op: 169,
      st: -590,
      bm: 0
    }, {
      ddd: 0,
      ind: 19,
      ty: 4,
      nm: "Shape Layer 6",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [244, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 38,
      op: 44,
      st: -715,
      bm: 0
    }, {
      ddd: 0,
      ind: 20,
      ty: 4,
      nm: "Shape Layer 5",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [244, 36, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.596078431373, 0.505882352941, 0.4, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 0,
      op: 500,
      st: 0,
      bm: 0
    }, {
      ddd: 0,
      ind: 21,
      ty: 4,
      nm: "Shape Layer 35",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 740,
      op: 740.252525252525,
      st: -13,
      bm: 0
    }, {
      ddd: 0,
      ind: 22,
      ty: 4,
      nm: "Shape Layer 29",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 617,
      op: 617.252525252525,
      st: -136,
      bm: 0
    }, {
      ddd: 0,
      ind: 23,
      ty: 4,
      nm: "Shape Layer 23",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 492,
      op: 498,
      st: -261,
      bm: 0
    }, {
      ddd: 0,
      ind: 24,
      ty: 4,
      nm: "Shape Layer 17",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 366,
      op: 372,
      st: -387,
      bm: 0
    }, {
      ddd: 0,
      ind: 25,
      ty: 4,
      nm: "Shape Layer 4",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 109,
      op: 115,
      st: -644,
      bm: 0
    }, {
      ddd: 0,
      ind: 26,
      ty: 4,
      nm: "Shape Layer 34",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 721,
      op: 721.252525252525,
      st: -32,
      bm: 0
    }, {
      ddd: 0,
      ind: 27,
      ty: 4,
      nm: "Shape Layer 28",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 598,
      op: 598.252525252525,
      st: -155,
      bm: 0
    }, {
      ddd: 0,
      ind: 28,
      ty: 4,
      nm: "Shape Layer 22",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 473,
      op: 477,
      st: -280,
      bm: 0
    }, {
      ddd: 0,
      ind: 29,
      ty: 4,
      nm: "Shape Layer 16",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 347,
      op: 351,
      st: -406,
      bm: 0
    }, {
      ddd: 0,
      ind: 30,
      ty: 4,
      nm: "Shape Layer 3",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 100,
      op: 104,
      st: -653,
      bm: 0
    }, {
      ddd: 0,
      ind: 31,
      ty: 4,
      nm: "Shape Layer 33",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 659,
      op: 659.252525252525,
      st: -94,
      bm: 0
    }, {
      ddd: 0,
      ind: 32,
      ty: 4,
      nm: "Shape Layer 27",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 536,
      op: 536.252525252525,
      st: -217,
      bm: 0
    }, {
      ddd: 0,
      ind: 33,
      ty: 4,
      nm: "Shape Layer 21",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 411,
      op: 417,
      st: -342,
      bm: 0
    }, {
      ddd: 0,
      ind: 34,
      ty: 4,
      nm: "Shape Layer 15",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 285,
      op: 291,
      st: -468,
      bm: 0
    }, {
      ddd: 0,
      ind: 35,
      ty: 4,
      nm: "Shape Layer 9",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 163,
      op: 169,
      st: -590,
      bm: 0
    }, {
      ddd: 0,
      ind: 36,
      ty: 4,
      nm: "Shape Layer 2",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 31, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.85882358925, 0.725490196078, 0.580392156863, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 38,
      op: 44,
      st: -715,
      bm: 0
    }, {
      ddd: 0,
      ind: 37,
      ty: 4,
      nm: "Shape Layer 1",
      parent: 3,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [0, 36, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          d: 1,
          ty: "el",
          s: {
            a: 0,
            k: [56.203, 56.203],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: "Ellipse Path 1",
          mn: "ADBE Vector Shape - Ellipse",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.38431372549, 0.38431372549, 0.38431372549, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.596078431373, 0.505882352941, 0.4, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-126.375, -37.277],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Ellipse 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 0,
      op: 500,
      st: 0,
      bm: 0
    }, {
      ddd: 0,
      ind: 38,
      ty: 4,
      nm: "Face",
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [315.5, 316, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [-160, -102, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [274.927, 274.927, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          ty: "rc",
          d: 1,
          s: {
            a: 0,
            k: [230.953, 230.953],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 4
          },
          nm: "Rectangle Path 1",
          mn: "ADBE Vector Shape - Rect",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [1, 1, 1, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.862745157878, 0.725490196078, 0.572549019608, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-160, -102],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Rectangle 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 0,
      op: 500,
      st: 0,
      bm: 0
    }]
  }, {
    id: "comp_1",
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "Face",
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [315.5, 316, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [-160, -102, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [274.927, 274.927, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          ty: "rc",
          d: 1,
          s: {
            a: 0,
            k: [230.953, 230.953],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 4
          },
          nm: "Rectangle Path 1",
          mn: "ADBE Vector Shape - Rect",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [1, 1, 1, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.862745157878, 0.725490196078, 0.572549019608, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-160, -102],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Rectangle 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 0,
      op: 4502,
      st: 0,
      bm: 0
    }]
  }, {
    id: "comp_2",
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "Face",
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [315.5, 316, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [-160, -102, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [274.927, 274.927, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          ty: "rc",
          d: 1,
          s: {
            a: 0,
            k: [230.953, 230.953],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 4
          },
          nm: "Rectangle Path 1",
          mn: "ADBE Vector Shape - Rect",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [1, 1, 1, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.776470648074, 0.654901960784, 0.513725490196, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-160, -102],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Rectangle 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 0,
      op: 4502,
      st: 0,
      bm: 0
    }]
  }, {
    id: "comp_3",
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "Shape Layer 1",
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [124, 496, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [44, 44, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          ind: 0,
          ty: "sh",
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0], [0, 0]],
              v: [[-129, 143], [-129, 175], [130, 177], [129, 145]],
              c: true
            },
            ix: 2
          },
          nm: "Path 1",
          mn: "ADBE Vector Shape - Group",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.596078431373, 0.505882352941, 0.400000029919, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.310983455882, 0.310983455882, 0.310983455882, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [0, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Shape 3",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }, {
        ty: "gr",
        it: [{
          ind: 0,
          ty: "sh",
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
              v: [[-57, -188], [-98, -117], [-74, -117], [-74, 125], [-40, 126], [-40, -118], [-16, -120]],
              c: true
            },
            ix: 2
          },
          nm: "Path 1",
          mn: "ADBE Vector Shape - Group",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.596078431373, 0.505882352941, 0.400000029919, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.310983455882, 0.310983455882, 0.310983455882, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [111, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Shape 2",
        np: 3,
        cix: 2,
        ix: 2,
        mn: "ADBE Vector Group",
        hd: false
      }, {
        ty: "gr",
        it: [{
          ind: 0,
          ty: "sh",
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
              v: [[-57, -188], [-98, -117], [-74, -117], [-74, 125], [-40, 126], [-40, -118], [-16, -120]],
              c: true
            },
            ix: 2
          },
          nm: "Path 1",
          mn: "ADBE Vector Shape - Group",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [0.596078431373, 0.505882352941, 0.400000029919, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.310983455882, 0.310983455882, 0.310983455882, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [0, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Shape 1",
        np: 3,
        cix: 2,
        ix: 3,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 0,
      op: 4502,
      st: 0,
      bm: 0
    }, {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "Face",
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [315.5, 316, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [-160, -102, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [274.927, 274.927, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          ty: "rc",
          d: 1,
          s: {
            a: 0,
            k: [230.953, 230.953],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 4
          },
          nm: "Rectangle Path 1",
          mn: "ADBE Vector Shape - Rect",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [1, 1, 1, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.776470648074, 0.654901960784, 0.513725490196, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-160, -102],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Rectangle 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 0,
      op: 4502,
      st: 0,
      bm: 0
    }]
  }, {
    id: "comp_4",
    layers: [{
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: "Face",
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [315.5, 316, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [-160, -102, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [274.927, 274.927, 100],
          ix: 6
        }
      },
      ao: 0,
      shapes: [{
        ty: "gr",
        it: [{
          ty: "rc",
          d: 1,
          s: {
            a: 0,
            k: [230.953, 230.953],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 4
          },
          nm: "Rectangle Path 1",
          mn: "ADBE Vector Shape - Rect",
          hd: false
        }, {
          ty: "st",
          c: {
            a: 0,
            k: [1, 1, 1, 1],
            ix: 3
          },
          o: {
            a: 0,
            k: 100,
            ix: 4
          },
          w: {
            a: 0,
            k: 0,
            ix: 5
          },
          lc: 1,
          lj: 1,
          ml: 4,
          ml2: {
            a: 0,
            k: 4,
            ix: 8
          },
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false
        }, {
          ty: "fl",
          c: {
            a: 0,
            k: [0.776470648074, 0.654901960784, 0.513725490196, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          nm: "Fill 1",
          mn: "ADBE Vector Graphic - Fill",
          hd: false
        }, {
          ty: "tr",
          p: {
            a: 0,
            k: [-160, -102],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: "Transform"
        }],
        nm: "Rectangle 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }],
      ip: 0,
      op: 4502,
      st: 0,
      bm: 0
    }]
  }],
  layers: [{
    ddd: 1,
    ind: 1,
    ty: 4,
    nm: "BINO1",
    parent: 3,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      rx: {
        a: 0,
        k: 0,
        ix: 8
      },
      ry: {
        a: 0,
        k: 0,
        ix: 9
      },
      rz: {
        a: 0,
        k: 0,
        ix: 10
      },
      or: {
        a: 0,
        k: [0, 40, 0],
        ix: 7
      },
      p: {
        a: 0,
        k: [-903.575, -48.619, 44.166],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [166.667, 166.667, 166.667],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: "gr",
      it: [{
        ind: 0,
        ty: "sh",
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[2.145, 7.292], [0, -8.251], [-9.866, -4.289], [-1.716, 1.287], [13.55, -0.616]],
            o: [[-1.746, -5.935], [0, 7.292], [9.866, 4.289], [1.716, -1.287], [-9.437, 0.429]],
            v: [[579.495, 40.602], [571.774, 42.318], [582.068, 61.191], [599.655, 62.049], [592.363, 54.328]],
            c: true
          },
          ix: 2
        },
        nm: "Path 1",
        mn: "ADBE Vector Shape - Group",
        hd: false
      }, {
        ty: "st",
        c: {
          a: 0,
          k: [0.23529399797, 0.525489956725, 0.521568986481, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 0,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        ml2: {
          a: 0,
          k: 4,
          ix: 8
        },
        nm: "Stroke 1",
        mn: "ADBE Vector Graphic - Stroke",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [0.494592554429, 1, 0.936916994581, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        nm: "Fill 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: false
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transform"
      }],
      nm: "Shape 1",
      np: 3,
      cix: 2,
      ix: 1,
      mn: "ADBE Vector Group",
      hd: false
    }, {
      ty: "gr",
      it: [{
        d: 1,
        ty: "el",
        s: {
          a: 0,
          k: [52.049, 61.378],
          ix: 2
        },
        p: {
          a: 0,
          k: [-3, -8],
          ix: 3
        },
        nm: "Ellipse Path 1",
        mn: "ADBE Vector Shape - Ellipse",
        hd: false
      }, {
        ty: "st",
        c: {
          a: 0,
          k: [0.23529399797, 0.525489956725, 0.521568986481, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 0,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        ml2: {
          a: 0,
          k: 4,
          ix: 8
        },
        nm: "Stroke 1",
        mn: "ADBE Vector Graphic - Stroke",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [0.151939885757, 0.716819852941, 0.646313715916, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        nm: "Fill 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: false
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [593.08, 46.131],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transform"
      }],
      nm: "Ellipse 1",
      np: 3,
      cix: 2,
      ix: 2,
      mn: "ADBE Vector Group",
      hd: false
    }, {
      ty: "gr",
      it: [{
        ty: "rc",
        d: 1,
        s: {
          a: 0,
          k: [135.473, 75.242],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        r: {
          a: 0,
          k: 70,
          ix: 4
        },
        nm: "Rectangle Path 1",
        mn: "ADBE Vector Shape - Rect",
        hd: false
      }, {
        ty: "st",
        c: {
          a: 0,
          k: [0.23529399797, 0.525489956725, 0.521568986481, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 0,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        ml2: {
          a: 0,
          k: 4,
          ix: 8
        },
        nm: "Stroke 1",
        mn: "ADBE Vector Graphic - Stroke",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [0.125683758306, 0.155892869538, 0.249525122549, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        nm: "Fill 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: false
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [557.48, 37.61],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transform"
      }],
      nm: "Rectangle 2",
      np: 3,
      cix: 2,
      ix: 3,
      mn: "ADBE Vector Group",
      hd: false
    }, {
      ty: "gr",
      it: [{
        ty: "rc",
        d: 1,
        s: {
          a: 0,
          k: [63.473, 37.242],
          ix: 2
        },
        p: {
          a: 0,
          k: [-59, 0],
          ix: 3
        },
        r: {
          a: 0,
          k: 70,
          ix: 4
        },
        nm: "Rectangle Path 1",
        mn: "ADBE Vector Shape - Rect",
        hd: false
      }, {
        ty: "st",
        c: {
          a: 0,
          k: [0.23529399797, 0.525489956725, 0.521568986481, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 0,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        ml2: {
          a: 0,
          k: 4,
          ix: 8
        },
        nm: "Stroke 1",
        mn: "ADBE Vector Graphic - Stroke",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [0.037872587466, 0.046910536523, 0.074923406863, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        nm: "Fill 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: false
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [557.48, 37.61],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transform"
      }],
      nm: "Rectangle 1",
      np: 3,
      cix: 2,
      ix: 4,
      mn: "ADBE Vector Group",
      hd: false
    }],
    ip: 0,
    op: 125,
    st: -126,
    bm: 0
  }, {
    ddd: 1,
    ind: 2,
    ty: 4,
    nm: "BINO2",
    parent: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      rx: {
        a: 0,
        k: 0,
        ix: 8
      },
      ry: {
        a: 0,
        k: 0,
        ix: 9
      },
      rz: {
        a: 0,
        k: 0,
        ix: 10
      },
      or: {
        a: 0,
        k: [0, 0, 0],
        ix: 7
      },
      p: {
        a: 0,
        k: [74, -4, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: "gr",
      it: [{
        ind: 0,
        ty: "sh",
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[2.145, 7.292], [0, -8.251], [-9.866, -4.289], [-1.716, 1.287], [13.55, -0.616]],
            o: [[-1.746, -5.935], [0, 7.292], [9.866, 4.289], [1.716, -1.287], [-9.437, 0.429]],
            v: [[579.495, 40.602], [571.774, 42.318], [582.068, 61.191], [599.655, 62.049], [592.363, 54.328]],
            c: true
          },
          ix: 2
        },
        nm: "Path 1",
        mn: "ADBE Vector Shape - Group",
        hd: false
      }, {
        ty: "st",
        c: {
          a: 0,
          k: [0.23529399797, 0.525489956725, 0.521568986481, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 0,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        ml2: {
          a: 0,
          k: 4,
          ix: 8
        },
        nm: "Stroke 1",
        mn: "ADBE Vector Graphic - Stroke",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [0.494592554429, 1, 0.936916994581, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        nm: "Fill 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: false
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transform"
      }],
      nm: "Shape 1",
      np: 3,
      cix: 2,
      ix: 1,
      mn: "ADBE Vector Group",
      hd: false
    }, {
      ty: "gr",
      it: [{
        d: 1,
        ty: "el",
        s: {
          a: 0,
          k: [52.049, 61.378],
          ix: 2
        },
        p: {
          a: 0,
          k: [-3, -8],
          ix: 3
        },
        nm: "Ellipse Path 1",
        mn: "ADBE Vector Shape - Ellipse",
        hd: false
      }, {
        ty: "st",
        c: {
          a: 0,
          k: [0.23529399797, 0.525489956725, 0.521568986481, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 0,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        ml2: {
          a: 0,
          k: 4,
          ix: 8
        },
        nm: "Stroke 1",
        mn: "ADBE Vector Graphic - Stroke",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [0.151939885757, 0.716819852941, 0.646313715916, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        nm: "Fill 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: false
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [593.08, 46.131],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transform"
      }],
      nm: "Ellipse 1",
      np: 3,
      cix: 2,
      ix: 2,
      mn: "ADBE Vector Group",
      hd: false
    }, {
      ty: "gr",
      it: [{
        ty: "rc",
        d: 1,
        s: {
          a: 0,
          k: [135.473, 75.242],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        r: {
          a: 0,
          k: 70,
          ix: 4
        },
        nm: "Rectangle Path 1",
        mn: "ADBE Vector Shape - Rect",
        hd: false
      }, {
        ty: "st",
        c: {
          a: 0,
          k: [0.23529399797, 0.525489956725, 0.521568986481, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 0,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        ml2: {
          a: 0,
          k: 4,
          ix: 8
        },
        nm: "Stroke 1",
        mn: "ADBE Vector Graphic - Stroke",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [0.125490196078, 0.156862745098, 0.250980392157, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        nm: "Fill 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: false
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [557.48, 37.61],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transform"
      }],
      nm: "Rectangle 2",
      np: 3,
      cix: 2,
      ix: 3,
      mn: "ADBE Vector Group",
      hd: false
    }, {
      ty: "gr",
      it: [{
        ty: "rc",
        d: 1,
        s: {
          a: 0,
          k: [63.473, 37.242],
          ix: 2
        },
        p: {
          a: 0,
          k: [-59, 0],
          ix: 3
        },
        r: {
          a: 0,
          k: 70,
          ix: 4
        },
        nm: "Rectangle Path 1",
        mn: "ADBE Vector Shape - Rect",
        hd: false
      }, {
        ty: "st",
        c: {
          a: 0,
          k: [0.23529399797, 0.525489956725, 0.521568986481, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 0,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        ml2: {
          a: 0,
          k: 4,
          ix: 8
        },
        nm: "Stroke 1",
        mn: "ADBE Vector Graphic - Stroke",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [0.125490196078, 0.156862745098, 0.250980392157, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        nm: "Fill 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: false
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [557.48, 37.61],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transform"
      }],
      nm: "Rectangle 1",
      np: 3,
      cix: 2,
      ix: 4,
      mn: "ADBE Vector Group",
      hd: false
    }],
    ip: 0,
    op: 125,
    st: -126,
    bm: 0
  }, {
    ddd: 1,
    ind: 3,
    ty: 3,
    nm: "Central",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 0,
        ix: 11
      },
      rx: {
        a: 0,
        k: 0,
        ix: 8
      },
      ry: {
        a: 1,
        k: [{
          i: {
            x: [0.833],
            y: [0.833]
          },
          o: {
            x: [0.167],
            y: [0.167]
          },
          n: ["0p833_0p833_0p167_0p167"],
          t: -126,
          s: [-54],
          e: [-75]
        }, {
          i: {
            x: [0.833],
            y: [0.833]
          },
          o: {
            x: [0.167],
            y: [0.167]
          },
          n: ["0p833_0p833_0p167_0p167"],
          t: -117,
          s: [-75],
          e: [-54]
        }, {
          i: {
            x: [0.833],
            y: [0.833]
          },
          o: {
            x: [0.167],
            y: [0.167]
          },
          n: ["0p833_0p833_0p167_0p167"],
          t: -109,
          s: [-54],
          e: [-46]
        }, {
          i: {
            x: [0.833],
            y: [1]
          },
          o: {
            x: [0.172],
            y: [0]
          },
          n: ["0p833_1_0p172_0"],
          t: -104,
          s: [-46],
          e: [-46]
        }, {
          i: {
            x: [0.833],
            y: [1]
          },
          o: {
            x: [0.167],
            y: [0]
          },
          n: ["0p833_1_0p167_0"],
          t: 24,
          s: [-46],
          e: [-40]
        }, {
          i: {
            x: [0.833],
            y: [1]
          },
          o: {
            x: [0.167],
            y: [0]
          },
          n: ["0p833_1_0p167_0"],
          t: 33,
          s: [-40],
          e: [-40]
        }, {
          i: {
            x: [0.833],
            y: [1]
          },
          o: {
            x: [0.167],
            y: [0]
          },
          n: ["0p833_1_0p167_0"],
          t: 82,
          s: [-40],
          e: [-46]
        }, {
          t: 92
        }],
        ix: 9
      },
      rz: {
        a: 1,
        k: [{
          i: {
            x: [0.833],
            y: [0.833]
          },
          o: {
            x: [0.167],
            y: [0.167]
          },
          n: ["0p833_0p833_0p167_0p167"],
          t: -126,
          s: [-9],
          e: [3]
        }, {
          i: {
            x: [0.833],
            y: [0.833]
          },
          o: {
            x: [0.167],
            y: [0.167]
          },
          n: ["0p833_0p833_0p167_0p167"],
          t: -117,
          s: [3],
          e: [-9]
        }, {
          i: {
            x: [0.833],
            y: [0.833]
          },
          o: {
            x: [0.167],
            y: [0.167]
          },
          n: ["0p833_0p833_0p167_0p167"],
          t: -109,
          s: [-9],
          e: [0]
        }, {
          i: {
            x: [0.833],
            y: [0.833]
          },
          o: {
            x: [0.167],
            y: [0.167]
          },
          n: ["0p833_0p833_0p167_0p167"],
          t: -104,
          s: [0],
          e: [0]
        }, {
          t: 24
        }],
        ix: 10
      },
      or: {
        a: 0,
        k: [0, 0, 0],
        ix: 7
      },
      p: {
        a: 0,
        k: [540, 540, 0],
        ix: 2
      },
      a: {
        a: 1,
        k: [{
          i: {
            x: 0.833,
            y: 0.833
          },
          o: {
            x: 0.167,
            y: 0.167
          },
          n: "0p833_0p833_0p167_0p167",
          t: -126,
          s: [0, 0, 0],
          e: [0, -30, 0],
          to: [0, -5, 0],
          ti: [0, 0, 0]
        }, {
          i: {
            x: 0.833,
            y: 0.833
          },
          o: {
            x: 0.167,
            y: 0.167
          },
          n: "0p833_0p833_0p167_0p167",
          t: -121,
          s: [0, -30, 0],
          e: [0, 0, 0],
          to: [0, 0, 0],
          ti: [0, 0, 0]
        }, {
          i: {
            x: 0.833,
            y: 0.833
          },
          o: {
            x: 0.167,
            y: 0.167
          },
          n: "0p833_0p833_0p167_0p167",
          t: -117,
          s: [0, 0, 0],
          e: [0, -30, 0],
          to: [0, 0, 0],
          ti: [0, 0, 0]
        }, {
          i: {
            x: 0.833,
            y: 0.833
          },
          o: {
            x: 0.167,
            y: 0.167
          },
          n: "0p833_0p833_0p167_0p167",
          t: -112,
          s: [0, -30, 0],
          e: [0, 0, 0],
          to: [0, 0, 0],
          ti: [0, -2.5, 0]
        }, {
          i: {
            x: 0.833,
            y: 0.833
          },
          o: {
            x: 0.167,
            y: 0.167
          },
          n: "0p833_0p833_0p167_0p167",
          t: -108,
          s: [0, 0, 0],
          e: [0, -15, 0],
          to: [0, 2.5, 0],
          ti: [0, 2.5, 0]
        }, {
          t: -104
        }],
        ix: 1
      },
      s: {
        a: 0,
        k: [48, 48, 48],
        ix: 6
      }
    },
    ao: 0,
    ip: 0,
    op: 125,
    st: -126,
    bm: 0
  }, {
    ddd: 1,
    ind: 4,
    ty: 4,
    nm: "Right Arm",
    parent: 3,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      rx: {
        a: 0,
        k: -6,
        ix: 8
      },
      ry: {
        a: 0,
        k: -19,
        ix: 9
      },
      rz: {
        a: 0,
        k: -91,
        ix: 10
      },
      or: {
        a: 0,
        k: [0, 90, 0],
        ix: 7
      },
      p: {
        a: 0,
        k: [-426.917, 38.5, -65.667],
        ix: 2
      },
      a: {
        a: 0,
        k: [-8, -18, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [173.333, 173.333, 173.333],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: "gr",
      it: [{
        ind: 0,
        ty: "sh",
        ix: 1,
        ks: {
          a: 1,
          k: [{
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -126,
            s: [{
              i: [[0, 0], [-5.988, -73.212], [-4.224, -7.353]],
              o: [[0, 0], [4.355, 53.247], [78.732, 137.045]],
              v: [[-8, -18], [17.705, 95.815], [7, 213]],
              c: false
            }],
            e: [{
              i: [[0, 0], [-5.988, -73.212], [-4.224, -7.353]],
              o: [[0, 0], [4.355, 53.247], [78.732, 137.045]],
              v: [[-8, -18], [-38.471, 97.997], [7, 213]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -117,
            s: [{
              i: [[0, 0], [-5.988, -73.212], [-4.224, -7.353]],
              o: [[0, 0], [4.355, 53.247], [78.732, 137.045]],
              v: [[-8, -18], [-38.471, 97.997], [7, 213]],
              c: false
            }],
            e: [{
              i: [[0, 0], [-5.988, -73.212], [-4.224, -7.353]],
              o: [[0, 0], [4.355, 53.247], [78.732, 137.045]],
              v: [[-8, -18], [17.705, 95.815], [7, 213]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -109,
            s: [{
              i: [[0, 0], [-5.988, -73.212], [-4.224, -7.353]],
              o: [[0, 0], [4.355, 53.247], [78.732, 137.045]],
              v: [[-8, -18], [17.705, 95.815], [7, 213]],
              c: false
            }],
            e: [{
              i: [[0, 0], [-5.988, -73.212], [-4.224, -7.353]],
              o: [[0, 0], [4.355, 53.247], [78.732, 137.045]],
              v: [[-8, -18], [-38.471, 97.997], [7, 213]],
              c: false
            }]
          }, {
            t: -104
          }],
          ix: 2
        },
        nm: "Path 1",
        mn: "ADBE Vector Shape - Group",
        hd: false
      }, {
        ty: "st",
        c: {
          a: 0,
          k: [0.596124387255, 0.505123721852, 0.401571236405, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 14,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        ml2: {
          a: 0,
          k: 4,
          ix: 8
        },
        nm: "Stroke 1",
        mn: "ADBE Vector Graphic - Stroke",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [0.22981004902, 0.22981004902, 0.22981004902, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        nm: "Fill 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: true
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transform"
      }],
      nm: "Shape 1",
      np: 3,
      cix: 2,
      ix: 1,
      mn: "ADBE Vector Group",
      hd: false
    }],
    ip: 0,
    op: 125,
    st: -126,
    bm: 0
  }, {
    ddd: 1,
    ind: 5,
    ty: 0,
    nm: "Face",
    parent: 3,
    refId: "comp_0",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      rx: {
        a: 0,
        k: 0,
        ix: 8
      },
      ry: {
        a: 0,
        k: 0,
        ix: 9
      },
      rz: {
        a: 0,
        k: 0,
        ix: 10
      },
      or: {
        a: 0,
        k: [0, 0, 0],
        ix: 7
      },
      p: {
        a: 0,
        k: [0, 0, -314],
        ix: 2
      },
      a: {
        a: 0,
        k: [316, 316, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    tm: {
      a: 1,
      k: [{
        i: {
          x: [0.833],
          y: [0.833]
        },
        o: {
          x: [0.167],
          y: [0.167]
        },
        n: ["0p833_0p833_0p167_0p167"],
        t: -126,
        s: [0],
        e: [20]
      }, {
        t: 6014
      }],
      ix: 2
    },
    w: 632,
    h: 632,
    ip: -126,
    op: 4376,
    st: -126,
    bm: 0
  }, {
    ddd: 1,
    ind: 6,
    ty: 0,
    nm: "Top",
    parent: 3,
    refId: "comp_1",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      rx: {
        a: 0,
        k: 90,
        ix: 8
      },
      ry: {
        a: 0,
        k: 0,
        ix: 9
      },
      rz: {
        a: 0,
        k: 0,
        ix: 10
      },
      or: {
        a: 0,
        k: [0, 0, 0],
        ix: 7
      },
      p: {
        a: 0,
        k: [0, -320, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [316, 316, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    w: 632,
    h: 632,
    ip: -126,
    op: 4376,
    st: -126,
    bm: 0
  }, {
    ddd: 1,
    ind: 7,
    ty: 0,
    nm: "Left Side",
    parent: 3,
    refId: "comp_2",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      rx: {
        a: 0,
        k: 0,
        ix: 8
      },
      ry: {
        a: 0,
        k: 90,
        ix: 9
      },
      rz: {
        a: 0,
        k: 0,
        ix: 10
      },
      or: {
        a: 0,
        k: [0, 0, 0],
        ix: 7
      },
      p: {
        a: 0,
        k: [318, 0, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [316, 316, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    w: 632,
    h: 632,
    ip: -126,
    op: 4376,
    st: -126,
    bm: 0
  }, {
    ddd: 1,
    ind: 8,
    ty: 0,
    nm: "Right Side",
    parent: 3,
    refId: "comp_3",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      rx: {
        a: 0,
        k: 0,
        ix: 8
      },
      ry: {
        a: 0,
        k: 90,
        ix: 9
      },
      rz: {
        a: 0,
        k: 0,
        ix: 10
      },
      or: {
        a: 0,
        k: [0, 0, 0],
        ix: 7
      },
      p: {
        a: 0,
        k: [-318, 0, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [316, 316, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    w: 632,
    h: 632,
    ip: -126,
    op: 4376,
    st: -126,
    bm: 0
  }, {
    ddd: 1,
    ind: 9,
    ty: 0,
    nm: "Back",
    parent: 3,
    refId: "comp_4",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      rx: {
        a: 0,
        k: 0,
        ix: 8
      },
      ry: {
        a: 0,
        k: 0,
        ix: 9
      },
      rz: {
        a: 0,
        k: 0,
        ix: 10
      },
      or: {
        a: 0,
        k: [0, 0, 0],
        ix: 7
      },
      p: {
        a: 0,
        k: [0, 0, 318],
        ix: 2
      },
      a: {
        a: 0,
        k: [316, 316, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    w: 632,
    h: 632,
    ip: -126,
    op: 4376,
    st: -126,
    bm: 0
  }, {
    ddd: 1,
    ind: 10,
    ty: 4,
    nm: "L_Leg",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      rx: {
        a: 0,
        k: 0,
        ix: 8
      },
      ry: {
        a: 0,
        k: -25,
        ix: 9
      },
      rz: {
        a: 0,
        k: 0,
        ix: 10
      },
      or: {
        a: 0,
        k: [0, 36, 0],
        ix: 7
      },
      p: {
        a: 0,
        k: [564.169, 572, 41.772],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [246, 246, 246],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: "gr",
      it: [{
        ind: 0,
        ty: "sh",
        ix: 1,
        ks: {
          a: 1,
          k: [{
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -133.667,
            s: [{
              i: [[0, 0], [0, 0]],
              o: [[0, 0], [0, 0]],
              v: [[1.25, 25.75], [47.75, 98.5]],
              c: false
            }],
            e: [{
              i: [[0, 0], [-14.25, -26.25]],
              o: [[9.75, 13.75], [-1.75, 13]],
              v: [[1.25, 25.75], [35.75, 97.25]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -132.625,
            s: [{
              i: [[0, 0], [-14.25, -26.25]],
              o: [[9.75, 13.75], [-1.75, 13]],
              v: [[1.25, 25.75], [35.75, 97.25]],
              c: false
            }],
            e: [{
              i: [[0, 0], [3.75, -33]],
              o: [[11.75, 12.25], [-1.75, 13]],
              v: [[-1.25, 29.25], [23.75, 95.25]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -131.584,
            s: [{
              i: [[0, 0], [3.75, -33]],
              o: [[11.75, 12.25], [-1.75, 13]],
              v: [[-1.25, 29.25], [23.75, 95.25]],
              c: false
            }],
            e: [{
              i: [[0, 0], [16, -33.25]],
              o: [[11.75, 12.25], [-1.75, 13]],
              v: [[-1.75, 34.5], [10.75, 97]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -130.542,
            s: [{
              i: [[0, 0], [16, -33.25]],
              o: [[11.75, 12.25], [-1.75, 13]],
              v: [[-1.75, 34.5], [10.75, 97]],
              c: false
            }],
            e: [{
              i: [[0, 0], [15, -24.75]],
              o: [[14.25, 25], [-1.75, 13]],
              v: [[-1, 39.75], [-1, 97.25]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -129.5,
            s: [{
              i: [[0, 0], [15, -24.75]],
              o: [[14.25, 25], [-1.75, 13]],
              v: [[-1, 39.75], [-1, 97.25]],
              c: false
            }],
            e: [{
              i: [[0, 0], [19.75, -22.75]],
              o: [[9, 26], [-1.75, 13]],
              v: [[-1, 39.75], [-13.25, 96.5]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -128.459,
            s: [{
              i: [[0, 0], [19.75, -22.75]],
              o: [[9, 26], [-1.75, 13]],
              v: [[-1, 39.75], [-13.25, 96.5]],
              c: false
            }],
            e: [{
              i: [[0, 0], [18, -32.75]],
              o: [[0.75, 19.25], [-1.75, 13]],
              v: [[-14.25, 34], [-24.75, 96.5]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -127.417,
            s: [{
              i: [[0, 0], [18, -32.75]],
              o: [[0.75, 19.25], [-1.75, 13]],
              v: [[-14.25, 34], [-24.75, 96.5]],
              c: false
            }],
            e: [{
              i: [[0, 0], [17, -28.25]],
              o: [[-7.75, 15.25], [-1.75, 13]],
              v: [[-4.75, 28.75], [-36.25, 96.75]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -126.375,
            s: [{
              i: [[0, 0], [17, -28.25]],
              o: [[-7.75, 15.25], [-1.75, 13]],
              v: [[-4.75, 28.75], [-36.25, 96.75]],
              c: false
            }],
            e: [{
              i: [[0, 0], [17, -28.25]],
              o: [[-9.75, 14.5], [-1.75, 13]],
              v: [[-6, 25.75], [-48.75, 98]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -125.334,
            s: [{
              i: [[0, 0], [17, -28.25]],
              o: [[-9.75, 14.5], [-1.75, 13]],
              v: [[-6, 25.75], [-48.75, 98]],
              c: false
            }],
            e: [{
              i: [[0, 0], [28.25, -16.75]],
              o: [[1, 17.25], [-1.75, 13]],
              v: [[-7, 29.25], [-43, 92.5]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -124.292,
            s: [{
              i: [[0, 0], [28.25, -16.75]],
              o: [[1, 17.25], [-1.75, 13]],
              v: [[-7, 29.25], [-43, 92.5]],
              c: false
            }],
            e: [{
              i: [[0, 0], [45.5, -13.75]],
              o: [[10, 13.25], [-1.75, 13]],
              v: [[-5.75, 34.5], [-29.75, 85.75]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -123.25,
            s: [{
              i: [[0, 0], [45.5, -13.75]],
              o: [[10, 13.25], [-1.75, 13]],
              v: [[-5.75, 34.5], [-29.75, 85.75]],
              c: false
            }],
            e: [{
              i: [[0, 0], [46.25, 0]],
              o: [[16, 2.25], [-1.75, 13]],
              v: [[-5.75, 34.5], [-15, 78.75]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -122.209,
            s: [{
              i: [[0, 0], [46.25, 0]],
              o: [[16, 2.25], [-1.75, 13]],
              v: [[-5.75, 34.5], [-15, 78.75]],
              c: false
            }],
            e: [{
              i: [[0, 0], [40.75, -27.5]],
              o: [[10, 0.75], [-1.75, 13]],
              v: [[-5.75, 34.5], [4.5, 74.5]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -121.167,
            s: [{
              i: [[0, 0], [40.75, -27.5]],
              o: [[10, 0.75], [-1.75, 13]],
              v: [[-5.75, 34.5], [4.5, 74.5]],
              c: false
            }],
            e: [{
              i: [[0, 0], [33.75, -31]],
              o: [[1.75, -0.25], [-9, 7]],
              v: [[3.25, 36.5], [18, 78]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -120.125,
            s: [{
              i: [[0, 0], [33.75, -31]],
              o: [[1.75, -0.25], [-9, 7]],
              v: [[3.25, 36.5], [18, 78]],
              c: false
            }],
            e: [{
              i: [[0, 0], [19, -48.5]],
              o: [[20, -2.75], [-1.75, 13]],
              v: [[3, 31.75], [32, 83.75]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -119.084,
            s: [{
              i: [[0, 0], [19, -48.5]],
              o: [[20, -2.75], [-1.75, 13]],
              v: [[3, 31.75], [32, 83.75]],
              c: false
            }],
            e: [{
              i: [[0, 0], [-6.75, -57.75]],
              o: [[15.5, 8], [-1.75, 13]],
              v: [[-3.25, 25.5], [42.5, 89.75]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -118.042,
            s: [{
              i: [[0, 0], [-6.75, -57.75]],
              o: [[15.5, 8], [-1.75, 13]],
              v: [[-3.25, 25.5], [42.5, 89.75]],
              c: false
            }],
            e: [{
              i: [[0, 0], [0, 0]],
              o: [[0, 0], [0, 0]],
              v: [[1.25, 25.75], [47.75, 98.5]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -117,
            s: [{
              i: [[0, 0], [0, 0]],
              o: [[0, 0], [0, 0]],
              v: [[1.25, 25.75], [47.75, 98.5]],
              c: false
            }],
            e: [{
              i: [[0, 0], [-14.25, -26.25]],
              o: [[9.75, 13.75], [-1.75, 13]],
              v: [[1.25, 25.75], [35.75, 97.25]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -115.959,
            s: [{
              i: [[0, 0], [-14.25, -26.25]],
              o: [[9.75, 13.75], [-1.75, 13]],
              v: [[1.25, 25.75], [35.75, 97.25]],
              c: false
            }],
            e: [{
              i: [[0, 0], [3.75, -33]],
              o: [[11.75, 12.25], [-1.75, 13]],
              v: [[-1.25, 29.25], [23.75, 95.25]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -114.917,
            s: [{
              i: [[0, 0], [3.75, -33]],
              o: [[11.75, 12.25], [-1.75, 13]],
              v: [[-1.25, 29.25], [23.75, 95.25]],
              c: false
            }],
            e: [{
              i: [[0, 0], [16, -33.25]],
              o: [[11.75, 12.25], [-1.75, 13]],
              v: [[-1.75, 34.5], [10.75, 97]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -113.875,
            s: [{
              i: [[0, 0], [16, -33.25]],
              o: [[11.75, 12.25], [-1.75, 13]],
              v: [[-1.75, 34.5], [10.75, 97]],
              c: false
            }],
            e: [{
              i: [[0, 0], [15, -24.75]],
              o: [[14.25, 25], [-1.75, 13]],
              v: [[-1, 39.75], [-1, 97.25]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -112.834,
            s: [{
              i: [[0, 0], [15, -24.75]],
              o: [[14.25, 25], [-1.75, 13]],
              v: [[-1, 39.75], [-1, 97.25]],
              c: false
            }],
            e: [{
              i: [[0, 0], [19.75, -22.75]],
              o: [[9, 26], [-1.75, 13]],
              v: [[-1, 39.75], [-13.25, 96.5]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -111.792,
            s: [{
              i: [[0, 0], [19.75, -22.75]],
              o: [[9, 26], [-1.75, 13]],
              v: [[-1, 39.75], [-13.25, 96.5]],
              c: false
            }],
            e: [{
              i: [[0, 0], [18, -32.75]],
              o: [[0.75, 19.25], [-1.75, 13]],
              v: [[-14.25, 34], [-24.75, 96.5]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -110.75,
            s: [{
              i: [[0, 0], [18, -32.75]],
              o: [[0.75, 19.25], [-1.75, 13]],
              v: [[-14.25, 34], [-24.75, 96.5]],
              c: false
            }],
            e: [{
              i: [[0, 0], [17, -28.25]],
              o: [[-7.75, 15.25], [-1.75, 13]],
              v: [[-4.75, 28.75], [-36.25, 96.75]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -109.709,
            s: [{
              i: [[0, 0], [17, -28.25]],
              o: [[-7.75, 15.25], [-1.75, 13]],
              v: [[-4.75, 28.75], [-36.25, 96.75]],
              c: false
            }],
            e: [{
              i: [[0, 0], [17, -28.25]],
              o: [[-9.75, 14.5], [-1.75, 13]],
              v: [[-6, 25.75], [-48.75, 98]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -108.667,
            s: [{
              i: [[0, 0], [17, -28.25]],
              o: [[-9.75, 14.5], [-1.75, 13]],
              v: [[-6, 25.75], [-48.75, 98]],
              c: false
            }],
            e: [{
              i: [[0, 0], [28.25, -16.75]],
              o: [[1, 17.25], [-1.75, 13]],
              v: [[-7, 29.25], [-43, 92.5]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -107.625,
            s: [{
              i: [[0, 0], [28.25, -16.75]],
              o: [[1, 17.25], [-1.75, 13]],
              v: [[-7, 29.25], [-43, 92.5]],
              c: false
            }],
            e: [{
              i: [[0, 0], [45.5, -13.75]],
              o: [[10, 13.25], [-1.75, 13]],
              v: [[-5.75, 34.5], [-29.75, 85.75]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -106.584,
            s: [{
              i: [[0, 0], [45.5, -13.75]],
              o: [[10, 13.25], [-1.75, 13]],
              v: [[-5.75, 34.5], [-29.75, 85.75]],
              c: false
            }],
            e: [{
              i: [[0, 0], [46.25, 0]],
              o: [[16, 2.25], [-1.75, 13]],
              v: [[-5.75, 34.5], [-15, 78.75]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -105.542,
            s: [{
              i: [[0, 0], [46.25, 0]],
              o: [[16, 2.25], [-1.75, 13]],
              v: [[-5.75, 34.5], [-15, 78.75]],
              c: false
            }],
            e: [{
              i: [[0, 0], [12.358, -25.295]],
              o: [[16, 2.25], [-1.75, 13]],
              v: [[-5.75, 34.5], [0.041, 97.652]],
              c: false
            }]
          }, {
            t: -103.999674479167
          }],
          ix: 2
        },
        nm: "Path 1",
        mn: "ADBE Vector Shape - Group",
        hd: false
      }, {
        ty: "st",
        c: {
          a: 0,
          k: [0.45853247549, 0.389574776444, 0.308624387255, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 6,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        ml2: {
          a: 0,
          k: 4,
          ix: 8
        },
        nm: "Stroke 1",
        mn: "ADBE Vector Graphic - Stroke",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        nm: "Fill 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: true
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transform"
      }],
      nm: "Shape 1",
      np: 3,
      cix: 2,
      ix: 1,
      mn: "ADBE Vector Group",
      hd: false
    }],
    ip: 0,
    op: 125,
    st: -183.666666666667,
    bm: 0
  }, {
    ddd: 1,
    ind: 11,
    ty: 4,
    nm: "R_Leg",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      rx: {
        a: 0,
        k: 0,
        ix: 8
      },
      ry: {
        a: 0,
        k: -25,
        ix: 9
      },
      rz: {
        a: 0,
        k: 0,
        ix: 10
      },
      or: {
        a: 0,
        k: [0, 36, 0],
        ix: 7
      },
      p: {
        a: 0,
        k: [507.741, 572, -35.894],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [246, 246, 246],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: "gr",
      it: [{
        ind: 0,
        ty: "sh",
        ix: 1,
        ks: {
          a: 1,
          k: [{
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -125.333,
            s: [{
              i: [[0, 0], [0, 0]],
              o: [[0, 0], [0, 0]],
              v: [[1.25, 25.75], [47.75, 98.5]],
              c: false
            }],
            e: [{
              i: [[0, 0], [-14.25, -26.25]],
              o: [[9.75, 13.75], [-1.75, 13]],
              v: [[1.25, 25.75], [35.75, 97.25]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -124.292,
            s: [{
              i: [[0, 0], [-14.25, -26.25]],
              o: [[9.75, 13.75], [-1.75, 13]],
              v: [[1.25, 25.75], [35.75, 97.25]],
              c: false
            }],
            e: [{
              i: [[0, 0], [3.75, -33]],
              o: [[11.75, 12.25], [-1.75, 13]],
              v: [[-1.25, 29.25], [23.75, 95.25]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -123.25,
            s: [{
              i: [[0, 0], [3.75, -33]],
              o: [[11.75, 12.25], [-1.75, 13]],
              v: [[-1.25, 29.25], [23.75, 95.25]],
              c: false
            }],
            e: [{
              i: [[0, 0], [16, -33.25]],
              o: [[11.75, 12.25], [-1.75, 13]],
              v: [[-1.75, 34.5], [10.75, 97]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -122.208,
            s: [{
              i: [[0, 0], [16, -33.25]],
              o: [[11.75, 12.25], [-1.75, 13]],
              v: [[-1.75, 34.5], [10.75, 97]],
              c: false
            }],
            e: [{
              i: [[0, 0], [15, -24.75]],
              o: [[14.25, 25], [-1.75, 13]],
              v: [[-1, 39.75], [-1, 97.25]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -121.167,
            s: [{
              i: [[0, 0], [15, -24.75]],
              o: [[14.25, 25], [-1.75, 13]],
              v: [[-1, 39.75], [-1, 97.25]],
              c: false
            }],
            e: [{
              i: [[0, 0], [19.75, -22.75]],
              o: [[9, 26], [-1.75, 13]],
              v: [[-1, 39.75], [-13.25, 96.5]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -120.125,
            s: [{
              i: [[0, 0], [19.75, -22.75]],
              o: [[9, 26], [-1.75, 13]],
              v: [[-1, 39.75], [-13.25, 96.5]],
              c: false
            }],
            e: [{
              i: [[0, 0], [18, -32.75]],
              o: [[0.75, 19.25], [-1.75, 13]],
              v: [[-14.25, 34], [-24.75, 96.5]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -119.083,
            s: [{
              i: [[0, 0], [18, -32.75]],
              o: [[0.75, 19.25], [-1.75, 13]],
              v: [[-14.25, 34], [-24.75, 96.5]],
              c: false
            }],
            e: [{
              i: [[0, 0], [17, -28.25]],
              o: [[-7.75, 15.25], [-1.75, 13]],
              v: [[-4.75, 28.75], [-36.25, 96.75]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -118.042,
            s: [{
              i: [[0, 0], [17, -28.25]],
              o: [[-7.75, 15.25], [-1.75, 13]],
              v: [[-4.75, 28.75], [-36.25, 96.75]],
              c: false
            }],
            e: [{
              i: [[0, 0], [17, -28.25]],
              o: [[-9.75, 14.5], [-1.75, 13]],
              v: [[-6, 25.75], [-48.75, 98]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -117,
            s: [{
              i: [[0, 0], [17, -28.25]],
              o: [[-9.75, 14.5], [-1.75, 13]],
              v: [[-6, 25.75], [-48.75, 98]],
              c: false
            }],
            e: [{
              i: [[0, 0], [28.25, -16.75]],
              o: [[1, 17.25], [-1.75, 13]],
              v: [[-7, 29.25], [-43, 92.5]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -115.958,
            s: [{
              i: [[0, 0], [28.25, -16.75]],
              o: [[1, 17.25], [-1.75, 13]],
              v: [[-7, 29.25], [-43, 92.5]],
              c: false
            }],
            e: [{
              i: [[0, 0], [45.5, -13.75]],
              o: [[10, 13.25], [-1.75, 13]],
              v: [[-5.75, 34.5], [-29.75, 85.75]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -114.917,
            s: [{
              i: [[0, 0], [45.5, -13.75]],
              o: [[10, 13.25], [-1.75, 13]],
              v: [[-5.75, 34.5], [-29.75, 85.75]],
              c: false
            }],
            e: [{
              i: [[0, 0], [46.25, 0]],
              o: [[16, 2.25], [-1.75, 13]],
              v: [[-5.75, 34.5], [-15, 78.75]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -113.875,
            s: [{
              i: [[0, 0], [46.25, 0]],
              o: [[16, 2.25], [-1.75, 13]],
              v: [[-5.75, 34.5], [-15, 78.75]],
              c: false
            }],
            e: [{
              i: [[0, 0], [40.75, -27.5]],
              o: [[10, 0.75], [-1.75, 13]],
              v: [[-5.75, 34.5], [4.5, 74.5]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -112.833,
            s: [{
              i: [[0, 0], [40.75, -27.5]],
              o: [[10, 0.75], [-1.75, 13]],
              v: [[-5.75, 34.5], [4.5, 74.5]],
              c: false
            }],
            e: [{
              i: [[0, 0], [33.75, -31]],
              o: [[1.75, -0.25], [-9, 7]],
              v: [[3.25, 36.5], [18, 78]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -111.792,
            s: [{
              i: [[0, 0], [33.75, -31]],
              o: [[1.75, -0.25], [-9, 7]],
              v: [[3.25, 36.5], [18, 78]],
              c: false
            }],
            e: [{
              i: [[0, 0], [19, -48.5]],
              o: [[20, -2.75], [-1.75, 13]],
              v: [[3, 31.75], [32, 83.75]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -110.75,
            s: [{
              i: [[0, 0], [19, -48.5]],
              o: [[20, -2.75], [-1.75, 13]],
              v: [[3, 31.75], [32, 83.75]],
              c: false
            }],
            e: [{
              i: [[0, 0], [-6.75, -57.75]],
              o: [[15.5, 8], [-1.75, 13]],
              v: [[-3.25, 25.5], [42.5, 89.75]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -109.708,
            s: [{
              i: [[0, 0], [-6.75, -57.75]],
              o: [[15.5, 8], [-1.75, 13]],
              v: [[-3.25, 25.5], [42.5, 89.75]],
              c: false
            }],
            e: [{
              i: [[0, 0], [0, 0]],
              o: [[0, 0], [0, 0]],
              v: [[1.25, 25.75], [47.75, 98.5]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -108.667,
            s: [{
              i: [[0, 0], [0, 0]],
              o: [[0, 0], [0, 0]],
              v: [[1.25, 25.75], [47.75, 98.5]],
              c: false
            }],
            e: [{
              i: [[0, 0], [-14.25, -26.25]],
              o: [[9.75, 13.75], [-1.75, 13]],
              v: [[1.25, 25.75], [35.75, 97.25]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -107.625,
            s: [{
              i: [[0, 0], [-14.25, -26.25]],
              o: [[9.75, 13.75], [-1.75, 13]],
              v: [[1.25, 25.75], [35.75, 97.25]],
              c: false
            }],
            e: [{
              i: [[0, 0], [3.75, -33]],
              o: [[11.75, 12.25], [-1.75, 13]],
              v: [[-1.25, 29.25], [23.75, 95.25]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -106.583,
            s: [{
              i: [[0, 0], [3.75, -33]],
              o: [[11.75, 12.25], [-1.75, 13]],
              v: [[-1.25, 29.25], [23.75, 95.25]],
              c: false
            }],
            e: [{
              i: [[0, 0], [16, -33.25]],
              o: [[11.75, 12.25], [-1.75, 13]],
              v: [[-1.75, 34.5], [10.75, 97]],
              c: false
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -105.542,
            s: [{
              i: [[0, 0], [16, -33.25]],
              o: [[11.75, 12.25], [-1.75, 13]],
              v: [[-1.75, 34.5], [10.75, 97]],
              c: false
            }],
            e: [{
              i: [[0, 0], [16, -33.25]],
              o: [[11.75, 12.25], [-1.75, 13]],
              v: [[-1.75, 34.5], [4.449, 97.61]],
              c: false
            }]
          }, {
            t: -104
          }],
          ix: 2
        },
        nm: "Path 1",
        mn: "ADBE Vector Shape - Group",
        hd: false
      }, {
        ty: "st",
        c: {
          a: 0,
          k: [0.45853247549, 0.389574776444, 0.308624387255, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 6,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        ml2: {
          a: 0,
          k: 4,
          ix: 8
        },
        nm: "Stroke 1",
        mn: "ADBE Vector Graphic - Stroke",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        nm: "Fill 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: true
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transform"
      }],
      nm: "Shape 1",
      np: 3,
      cix: 2,
      ix: 1,
      mn: "ADBE Vector Group",
      hd: false
    }],
    ip: 0,
    op: 125,
    st: -167,
    bm: 0
  }, {
    ddd: 0,
    ind: 12,
    ty: 4,
    nm: "Shape Layer 1",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 28,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [540, 540, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, -9, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: "gr",
      it: [{
        ind: 0,
        ty: "sh",
        ix: 1,
        ks: {
          a: 1,
          k: [{
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -126,
            s: [{
              i: [[0, 0], [0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0], [0, 0]],
              v: [[2, 228], [-154.069, 265.612], [29.931, 290.612], [157.517, 248.983]],
              c: true
            }],
            e: [{
              i: [[0, 0], [0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0], [0, 0]],
              v: [[-83, 247], [-143, 280.5], [44, 285], [98, 251]],
              c: true
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -117,
            s: [{
              i: [[0, 0], [0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0], [0, 0]],
              v: [[-83, 247], [-143, 280.5], [44, 285], [98, 251]],
              c: true
            }],
            e: [{
              i: [[0, 0], [0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0], [0, 0]],
              v: [[2, 228], [-154.069, 265.612], [29.931, 290.612], [157.517, 248.983]],
              c: true
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -109,
            s: [{
              i: [[0, 0], [0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0], [0, 0]],
              v: [[2, 228], [-154.069, 265.612], [29.931, 290.612], [157.517, 248.983]],
              c: true
            }],
            e: [{
              i: [[0, 0], [0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0], [0, 0]],
              v: [[2, 228], [-150, 259], [34, 284], [163.621, 256.104]],
              c: true
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: -104,
            s: [{
              i: [[0, 0], [0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0], [0, 0]],
              v: [[2, 228], [-150, 259], [34, 284], [163.621, 256.104]],
              c: true
            }],
            e: [{
              i: [[0, 0], [0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0], [0, 0]],
              v: [[2, 228], [-150, 259], [34, 284], [163.621, 256.104]],
              c: true
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: 24,
            s: [{
              i: [[0, 0], [0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0], [0, 0]],
              v: [[2, 228], [-150, 259], [34, 284], [163.621, 256.104]],
              c: true
            }],
            e: [{
              i: [[0, 0], [0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0], [0, 0]],
              v: [[31, 237], [-117, 256], [3, 288.5], [155.621, 272.104]],
              c: true
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: 32,
            s: [{
              i: [[0, 0], [0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0], [0, 0]],
              v: [[31, 237], [-117, 256], [3, 288.5], [155.621, 272.104]],
              c: true
            }],
            e: [{
              i: [[0, 0], [0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0], [0, 0]],
              v: [[31, 237], [-117, 256], [3, 288.5], [155.621, 272.104]],
              c: true
            }]
          }, {
            i: {
              x: 0.833,
              y: 0.833
            },
            o: {
              x: 0.167,
              y: 0.167
            },
            n: "0p833_0p833_0p167_0p167",
            t: 81,
            s: [{
              i: [[0, 0], [0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0], [0, 0]],
              v: [[31, 237], [-117, 256], [3, 288.5], [155.621, 272.104]],
              c: true
            }],
            e: [{
              i: [[0, 0], [0, 0], [0, 0], [0, 0]],
              o: [[0, 0], [0, 0], [0, 0], [0, 0]],
              v: [[2, 228], [-150, 259], [34, 284], [163.621, 256.104]],
              c: true
            }]
          }, {
            t: 92
          }],
          ix: 2
        },
        nm: "Path 1",
        mn: "ADBE Vector Shape - Group",
        hd: false
      }, {
        ty: "st",
        c: {
          a: 0,
          k: [0.596078431373, 0.505882352941, 0.400000029919, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 0,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        ml2: {
          a: 0,
          k: 4,
          ix: 8
        },
        nm: "Stroke 1",
        mn: "ADBE Vector Graphic - Stroke",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [0, 0, 0, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        nm: "Fill 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: false
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transform"
      }],
      nm: "Shape 1",
      np: 3,
      cix: 2,
      ix: 1,
      mn: "ADBE Vector Group",
      hd: false
    }],
    ip: 0,
    op: 125,
    st: -126,
    bm: 0
  }, {
    ddd: 1,
    ind: 13,
    ty: 4,
    nm: "Left Arm",
    parent: 3,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      rx: {
        a: 0,
        k: 0,
        ix: 8
      },
      ry: {
        a: 0,
        k: 155,
        ix: 9
      },
      rz: {
        a: 1,
        k: [{
          i: {
            x: [0.833],
            y: [0.833]
          },
          o: {
            x: [0.167],
            y: [0.167]
          },
          n: ["0p833_0p833_0p167_0p167"],
          t: -126,
          s: [-25],
          e: [25]
        }, {
          i: {
            x: [0.833],
            y: [0.833]
          },
          o: {
            x: [0.167],
            y: [0.167]
          },
          n: ["0p833_0p833_0p167_0p167"],
          t: -117,
          s: [25],
          e: [-25]
        }, {
          i: {
            x: [0.833],
            y: [0.833]
          },
          o: {
            x: [0.167],
            y: [0.167]
          },
          n: ["0p833_0p833_0p167_0p167"],
          t: -109,
          s: [-25],
          e: [0]
        }, {
          t: -104
        }],
        ix: 10
      },
      or: {
        a: 0,
        k: [0, 270, 0],
        ix: 7
      },
      p: {
        a: 0,
        k: [322.917, 38.5, -8.333],
        ix: 2
      },
      a: {
        a: 0,
        k: [-8, -18, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [173.333, 173.333, 173.333],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: "gr",
      it: [{
        ind: 0,
        ty: "sh",
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [-80, -101]],
            o: [[0, 0], [98.134, 123.894]],
            v: [[-8, -18], [7, 213]],
            c: false
          },
          ix: 2
        },
        nm: "Path 1",
        mn: "ADBE Vector Shape - Group",
        hd: false
      }, {
        ty: "st",
        c: {
          a: 0,
          k: [0.596124387255, 0.505123721852, 0.401571236405, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 14,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        ml2: {
          a: 0,
          k: 4,
          ix: 8
        },
        nm: "Stroke 1",
        mn: "ADBE Vector Graphic - Stroke",
        hd: false
      }, {
        ty: "fl",
        c: {
          a: 0,
          k: [0.22981004902, 0.22981004902, 0.22981004902, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        nm: "Fill 1",
        mn: "ADBE Vector Graphic - Fill",
        hd: true
      }, {
        ty: "tr",
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: "Transform"
      }],
      nm: "Shape 1",
      np: 3,
      cix: 2,
      ix: 1,
      mn: "ADBE Vector Group",
      hd: false
    }],
    ip: 0,
    op: 125,
    st: -126,
    bm: 0
  }],
  markers: []
};